define((require) => {
    "use strict";

    var Browser                         = require("shared/services/Browser"),
        EditorCommentsRenderer          = require("editor/ui/experience/editor/EditorCommentsRenderer"),
        ExperienceEditorSizeController  = require("ui/editor/ExperienceEditorSizeController"),
        ImprovedView                    = require("editor/zbone/ImprovedView"),
        Marionette                      = require("marionette"),
        Preconditions                   = require("shared/util/Preconditions"),
        SceneEditor                     = require("ui/editor/SceneEditor"),
        template                        = require("ui/editor/ExperienceEditor.tpl"),
        _debounce                       = require("lodash/debounce");
    /**
     * SceneCollection view class
     * @type {*}
     */
    var SceneCollectionView = Marionette.CollectionView.extend({

        itemViewOptions: function() {
            return  {
                experienceModel: this.options.experienceModel,
                viewScope: this.options.viewScope
            };
        },

        attributes: {
            "data-dragselectable": true
        },

        itemView: SceneEditor,

        itemEvents: {
            "moveScene": "_moveScene"
        },

        _moving: false,

        _moveScene: function(event, sceneView, direction) {
            if (this._moving) {
                return;
            }

            this._moving = true;

            var sceneNumber = sceneView.model.getSceneIndex(),
                newSceneNumber = (direction === "forwards") ? sceneNumber + 1 : sceneNumber - 1,
                adjacentSceneModel = this.collection.at(newSceneNumber - 1),
                adjacentSceneView = this.children.findByModel(adjacentSceneModel),
                el = sceneView.$el,
                el2 = adjacentSceneView.$el,
                scale = this.viewScope.viewModel.get("zoomModel").get("scale"),
                distance = (el2.position().left - el.position().left) / scale,
                primaryDirection = distance > 0 ? "moving-right" : "moving-left",
                secondayDirection = distance > 0 ? "moving-left" : "moving-right";

            el.addClass("moving primary " + primaryDirection).css("transform", "translateX(" + distance + "px)");
            el2.addClass("moving " + secondayDirection).css("transform", "translateX(" + -distance + "px)");

            // Reordering the scenes in the experience model forces a rerendering which ruins
            // the animation, so we wait for the animation to finish first (1s).
            el.one(Browser.animationEndEventName(), () => {
                this.viewScope.experienceModel.swapScenes(sceneView.model, adjacentSceneModel);
                this.render();

                // TODO: Find a solution that does not require us to manually trigger 'show'
                // Trigger 'show' here to invoke 'onShow' for widget views
                this.trigger("show");

                this._moving = false;
            });
        },

        getWidgetBoundingBox: function(widgetModel) {
            Preconditions.isModel(widgetModel);

            var sceneEditor = this.children.find((sceneEditor) => {
                    return sceneEditor.sceneWidgetCollectionView.widgetCollectionViews().some((widgetCollectionView) => {
                        return widgetCollectionView.collection.get(widgetModel);
                    });
                }),
                widgetView;

            sceneEditor.sceneWidgetCollectionView.widgetCollectionViews().some((widgetCollectionView) => {
                const found = widgetCollectionView.children.findByModel(widgetModel);
                if (found) {
                    widgetView = found;
                    return true; // signal that we have found the widgetView and no more looping through widget collection views is needed
                }
                return false;
            });

            return widgetView.getBoundingBox(true);
        }

    });


    /**
     * ExperienceEditor class
     */
    return ImprovedView.extend({

        className: "experience-editor",

        attributes: {
            "data-dragselectable": true
        },

        template: template,

        _commentsRenderer: null,
        _sceneCollectionView: null,

        templateHelpers: function() {
            return {
                spectatorMode: this.viewScope.spectatorMode
            };
        },

        regions: {
            scenesRegion: ".scenes-region"
        },

        ui: {
            scenesRegion: ".scenes-region"
        },

        modelEvents: {
            "change:selectedWidgetId": "_widgetHighlight"
        },

        viewScope: function() {
            return {
                experienceModel: this.model
            };
        },

        onRender: function() {
            var viewModel = this.viewScope.viewModel;
            this.$el.addClass(this.model.get("id"));

            // Initialize the comments renderer
            this._commentsRenderer = new EditorCommentsRenderer(this.$el, this.viewScope);
            viewModel.set("commentsRenderer", this._commentsRenderer);
            this.ui.scenesRegion[0].addEventListener("mousemove", _debounce((event) => this._trackMousePosition(event), 50, {
                maxWait: 200
            }));
        },

        _trackMousePosition(event) {
            window.mouseCoords = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        },

        _widgetHighlight() {
            // Clear previous highlights, if exists
            this.viewScope.viewModel
                .getCurrentScene()
                .get("widgets")
                .models.forEach((widget) => {
                    if (widget.get("highlighted")) {
                        widget.set("highlighted", null);
                    }
                });
            this.model
                .get("backgroundScene")
                .get("widgets")
                .models.forEach((widget) => {
                    if (widget.get("highlighted")) {
                        widget.set("highlighted", null);
                    }
                });
            this.model
                .get("overlayScene")
                .get("widgets")
                .models.forEach((widget) => {
                    if (widget.get("highlighted")) {
                        widget.set("highlighted", null);
                    }
                });

            if (this.model.has("selectedWidgetId")) {
                // Add shadow to the Experience editor
                this.$el.addClass("shadowed");

                const selectedId = this.model.get("selectedWidgetId");
                if (this.viewScope.viewModel.getCurrentScene().getWidgetByID(selectedId)) {
                    // current scene widget
                    this.viewScope.viewModel
                        .getCurrentScene()
                        .getWidgetByID(selectedId)
                        .set("highlighted", true);
                } else if (this.model.get("backgroundScene").getWidgetByID(selectedId)) {
                    // background scene widget
                    this.model
                        .get("backgroundScene")
                        .getWidgetByID(selectedId)
                        .set("highlighted", true);
                } else {
                    // overlay scene widget
                    this.model
                        .get("overlayScene")
                        .getWidgetByID(selectedId)
                        .set("highlighted", true);
                }
            } else {
                // Remove shadow from Experience editor
                this.$el.removeClass("shadowed");
                this.viewScope.viewModel.trigger("nestedWidgetTabOrderMetaDataChange");
            }
        },

        onShow: function() {
            this._sceneCollectionView = new SceneCollectionView({
                collection: this.model.get("scenes"),
                experienceModel: this.model,
                viewScope: this.viewScope
            });

            this.scenesRegion.show(this._sceneCollectionView);

            this._experienceEditorSizeController = new ExperienceEditorSizeController({
                container: this.$el,
                experience: this.model,
                commentBoundsProvider: this.getCommentBoundsProvider.bind(this),
                getWidgetBoundsProvider: this.getWidgetBoundsProvider.bind(this),
                viewModel: this.viewScope.viewModel
            });
            this._experienceEditorSizeController.start();
        },

        onClose: function() {
            // Dispose the comment renderer
            this.ui.scenesRegion[0].removeEventListener("mousemove", this._trackMousePosition);
            this._commentsRenderer.dispose();
            this._experienceEditorSizeController.close();
        },

        getWidgetBoundsProvider: function(widgetModel) {
            return this._sceneCollectionView.getWidgetBoundingBox(widgetModel);
        },

        getCommentBoundsProvider: function(comment) {
            return this._commentsRenderer.getCommentBoundingBoxes(comment);
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/ExperienceEditor.js